exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tooltip{position:relative}.v-tooltip .v-tooltip-body{position:absolute;left:-56%;bottom:120%;z-index:99999;background:#fff;border-radius:4px;padding:8px 14px;color:#1f2937;min-width:8rem;box-shadow:0 0 14px rgba(0,0,0,.15);width:100%;text-align:center}.v-tooltip .v-tooltip-body:after{content:\"\";display:block;width:8px;height:8px;background-color:#fff;position:absolute;top:calc(100% - 4px);left:25%;transform:rotate(45deg)}", ""]);

// exports
